<template>
  <div class="label-item">{{ label }}</div>
</template>

<script>

export default {
  name: 'LabelItem',
  props: {
    label: {
      type: String,
      require: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .label-item {
    display: inline-block;
    padding: 0 10px;
    height: 20px;
    border: 1px solid #F8F8F8;
    color: var(--color-des);
    line-height: 20px;
    font-size: $font-size-sm;
  }
</style>
